var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import config from '../services/config';
import connectServerService from '../services/connect_server_service';
export var visitation = function visitation(siteApi, getToken) {
  return {
    recordingPreviewUrl: function recordingPreviewUrl(id) {
      return "".concat(config.api.url, "/visitation/recording/").concat(id, "/preview?token=").concat(getToken().accessToken);
    },
    index: function index(params) {
      return siteApi.get('/visitation', {
        params: params
      });
    },
    post: function post(data) {
      return siteApi.post('/visitation', data);
    },
    search: function search(params) {
      return siteApi.get('/visitation/search', {
        params: params
      });
    },
    delete: function _delete(id, note) {
      connectServerService.send({
        route: 'web/visitation/terminate',
        payload: {
          visitationId: id,
          cause: 'OfficerTerminated'
        }
      });
      return siteApi.delete("/visitation/".concat(id), {
        params: {
          note: note
        }
      });
    },
    checkInVisitor: function checkInVisitor(id) {
      return siteApi.put("/visitation/check-in-visitor/".concat(id));
    },
    pdfUrl: function pdfUrl(params) {
      if (params === void 0) {
        params = {};
      }
      return siteApi.buildUrl('/visitation/search.pdf', __assign(__assign({}, params), {
        token: getToken().accessToken
      }));
    }
  };
};